import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_AI_AGENT_STATE,
});

export const syncAiAgents = () => ({
  type: types.SYNC_AI_AGENTS.REQUEST,
});

export const syncAiAgentsSuccess = (aiAgents) => ({
  type: types.SYNC_AI_AGENTS.SUCCESS,
  aiAgents,
});

export const syncAiAgentsFailure = (error) => ({
  type: types.SYNC_AI_AGENTS.FAILURE,
  error,
});

export const createAiAgent = (aiAgent) => ({
  type: types.CREATE_AI_AGENT.REQUEST,
  aiAgent,
});

export const createAiAgentSuccess = () => ({
  type: types.CREATE_AI_AGENT.SUCCESS,
});

export const createAiAgentFailure = (error) => ({
  type: types.CREATE_AI_AGENT.FAILURE,
  error,
});

export const updateAiAgent = (aiAgent) => ({
  type: types.UPDATE_AI_AGENT.REQUEST,
  aiAgent,
});

export const updateAiAgentSuccess = () => ({
  type: types.UPDATE_AI_AGENT.SUCCESS,
});

export const updateAiAgentFailure = (error) => ({
  type: types.UPDATE_AI_AGENT.FAILURE,
  error,
});
